import React from 'react';
import FreelancerFeeItem from '../../../Domain/FreelancerFeeItem';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import FreelancerFeeService from '../../../Services/FreelancerFeeService';
import FeePanels from './FeePanels';
import FreelancerFeeSearchParams from './FreelancerFeeSearchParams';
import ShownOverWindowsEnum from '../../../Enums/ShownOverWindowsEnum';
import ApplyFeeForVendorsWindowDescription from './ApplyFeeForVendorsWindowDescription';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import AuthService from '../../../Services/authService';
import UserService from '../../../Services/userService';
import FreelancerUserService from '../../../Services/FreelancerUserService';
import FreelancerUserItem from '../../../Domain/FreelancerUserItem';
import FreelancerUserSearchParams from '../FreelancerUserAdmin/FreelancerUserSearchParams';
import GeneralEditWizzardBaseFigma from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';

class FreelancerFeeAdmin extends React.Component {
  static defaultProps = {
    searchItem: null,
    showSearchPanel: true,
  };

  constructor(props) {
    super(props);

    this.startSearch = this.startSearch.bind(this);
    FreelancerFeeItem.editFunction = this.editFunction.bind(this);
    FreelancerFeeItem.closeFunction = this.closeFunction.bind(this);
    FreelancerFeeItem.cloneThisFeeFunction = this.cloneThisFeeFunction.bind(this);
    FreelancerFeeItem.applyFeeForVendorFunction = this.applyFeeForVendorFunction.bind(this);

    let searchItem = new FreelancerFeeSearchParams();
    if (props.searchItem) {
      searchItem = props.searchItem;
    }

    if (props.freelancerFeeId) {
      searchItem.FreelancerFeeId = props.freelancerFeeId.toString();
      searchItem.Office = '';
    }

    this.state = {
      itemList: [],
      selected: -1,
      selectedItem: null,
      applyFeeItem: null,
      orderBy: 'FreelancerFeeId',
      orderDirection: OrderDirectionsEnum.Asc,
      shownPanel:
        FreelancerFeeSearchParams.isThereAnySearchParameter(searchItem) && this.props.showSearchPanel
          ? ShownPanelsEnum.Search
          : ShownPanelsEnum.None,
      shownWindow: ShownOverWindowsEnum.None,
      searchItem: searchItem,
    };
  }

  editPanelOnClose(refresh) {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
    });
    if (refresh) {
      this.refresh();
    }
  }

  // The Fee Type select needs the vendor's up-to-date role flags (IsRM/IsDQ/...), which the
  // FreelancerFeeItem list row never carries (only the backend's vendor-user endpoint has them).
  // The old bespoke EditFeePanel fetched this itself in componentDidMount; the wizard's
  // windowDescription is declarative and can't await a network call while opening, so the fetch
  // is done here as host-prep before the panel is shown.
  getFreelancerUserRoleFlags(freelancerUserId) {
    return FreelancerUserService.GetFreelancerUserById(freelancerUserId)
      .then((result) => {
        const user = new FreelancerUserItem(result);
        return {
          IsRM: user.IsRM,
          IsDQ: user.IsDQ,
          IsKAM: user.IsKAM,
          IsBD: user.IsBD,
          IsBI: user.IsBI,
          IsIT: user.IsIT,
          IsHR: user.IsHR,
          IsMarketing: user.IsMarketing,
          IsFinance: user.IsFinance,
          IsFieldworkPartner: user.IsFieldworkPartner,
        };
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: FFA300');
        return {};
      });
  }

  editFunction(id, item, itemList) {
    this.getFreelancerUserRoleFlags(item.FreelancerUserId).then((roleFlags) => {
      this.setState({
        shownPanel: ShownPanelsEnum.EditItem,
        selected: id,
        selectedItem: { ...item, ...roleFlags },
      });
    });
  }

  closeFunction(id, item, itemList) {
    this.setState({
      shownPanel: ShownPanelsEnum.Close,
      selected: id,
      selectedItem: item,
    });
  }

  cloneThisFeeFunction(id, item, itemList) {
    this.getFreelancerUserRoleFlags(item.FreelancerUserId).then((roleFlags) => {
      this.setState({
        shownPanel: ShownPanelsEnum.AddNewItem,
        selected: id,
        selectedItem: { ...item, ...roleFlags },
      });
    });
  }

  // The old bespoke ApplyFeeForVendorsWindow fetched the eligible-vendor list itself in
  // componentDidMount. The wizard's windowDescription is declarative and can't await a network
  // call while opening, so the fetch is done here as host-prep before the panel is shown (same
  // async-hydration pattern as SurveyAdmin.clickOnAddSurvey).
  applyFeeForVendorFunction(item) {
    const searchItem = new FreelancerUserSearchParams();
    searchItem.PrimaryFreelancerUserName = item.FreelancerUserId.toString();
    searchItem.IncludePrimaryFreelancerUser = 'false';
    searchItem.ExcludedFeeId = item.FreelancerFeeId.toString();
    FreelancerUserService.GetFreelancerUserList('Id', 'Asc', 1, 1000, searchItem)
      .then((result) => {
        const availableVendors = FreelancerUserService.ConvertDBFreelancerUser(result.data);
        availableVendors.forEach((vendor) => {
          vendor.SelectedInList = false;
          vendor.DisplayLabel = `${vendor.FirstName} ${vendor.LastName} (${vendor.FreelancerUserId})`;
        });
        this.setState({
          selected: -1,
          shownWindow: ShownOverWindowsEnum.Apply,
          applyFeeItem: {
            ...item,
            AvailableVendors: availableVendors,
            SelectedVendorIds: [],
            UseOptFee: parseFloat(item.OptFee) >= 0,
            // Frozen copies for the read-only "Original ..." info fields - Fee/OptFee/Tier are
            // also the EDITABLE fields, so the display must not follow the user's edits.
            OriginalFee: item.Fee,
            OriginalOptFee: item.OptFee,
            OriginalTier: item.Tier,
          },
        });
      })
      .catch(() => ErrorMessage.SetErrorMessage('AFFVW65'));
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  closeEditFeePanel(editedItem) {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    this.refresh();
  }

  closeCloseFeePanel(result) {
    if (result && result.length > 0) {
      ErrorMessage.SetSuccess(
        `We removed assignments from the following invoice${result.length > 1 && 's'}: ${result.join(', ')}`
      );
    }
    this.setState({
      shownPanel: ShownPanelsEnum.None,
    });

    this.refresh();
  }

  clickOnOk(type, item, result) {
    switch (type) {
      case ShownPanelsEnum.Search:
        this.startSearch(item);
        break;
      case ShownPanelsEnum.EditItem:
        this.closeEditFeePanel(item);
        break;
      case ShownPanelsEnum.Close:
        this.closeCloseFeePanel(result);
        break;
      default:
        break;
    }
  }

  renderWindows() {
    return this.state.shownWindow === ShownOverWindowsEnum.Apply ? this.renderApplyFeeForVendorWindow() : null;
  }

  renderApplyFeeForVendorWindow = () => (
    <GeneralEditWizzardBaseFigma
      crudType={CrudTypesEnum.Create}
      editedItem={this.state.applyFeeItem}
      clickOnCancel={() => {
        // Old panel's clickOnCancel(false) path: just close, no reload.
        this.setState({ shownWindow: ShownOverWindowsEnum.None });
      }}
      clickOnSave={() => {
        // Old panel's clickOnCancel(true) path: close, reset the order, and refresh the list.
        // NOTE: the old code set an 'orderDir' key here, but the component's actual state field
        // is 'orderDirection' (see the constructor) - that assignment was a pre-existing no-op in
        // ApplyFeeForVendorsWindow.js, reproduced as-is rather than silently changing behavior.
        this.setState(
          {
            shownWindow: ShownOverWindowsEnum.None,
            orderBy: 'FreelancerFeeId',
            orderDir: OrderDirectionsEnum.Asc,
          },
          () => this.refresh()
        );
      }}
      windowDescription={ApplyFeeForVendorsWindowDescription}
      errorCode='AVW379'
    />
  );

  changeShownPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      this.refresh();
      panelId = ShownPanelsEnum.None;
    }
    this.setState({ shownPanel: panelId });
  }

  startSearch(searchItem) {
    if (
      AuthService.HasRoleArray(['FinanceAdmin_VendorMgtm', 'VendorInvoicingAdmin_*']) &&
      !AuthService.IsAdmin() &&
      !searchItem?.Office
    ) {
      searchItem = { ...searchItem, Office: UserService.GetOfficeIdOfLoggedInUser() };
    }
    this.setState({
      searchItem,
    });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <FeePanels
          shownPanel={this.state.shownPanel}
          clickOnOk={(type, item, result) => this.clickOnOk(type, item, result)}
          selectedItem={this.state.selectedItem}
          changeShownPanel={(panelId) => this.changeShownPanel(panelId)}
          searchItem={this.state.searchItem}
        />
        <TabOfDataTable
          type={FreelancerFeeItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={FreelancerFeeService.GetFreelancerFeeList}
          convertDBItemsFunction={FreelancerFeeService.ConvertDBFreelancerFee}
          searchItem={this.state.searchItem}
          searchParamsType={FreelancerFeeSearchParams}
          orderDirection={this.state.orderDirection}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          errorCode='FFA236'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search for id, vendor, client, survey or country...'
        />

        {this.renderWindows()}
      </div>
    );
  }
}

export default FreelancerFeeAdmin;
